
import React, { Component } from 'react'
import { Row, Col, Button, Tabs, message, Modal } from 'antd';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import $ from 'jquery';
import './style.css';


// Child Component
import About from './childs/about'

// Actions
import { 
    get_assets, 
    get_employee, 
    get_department, 
    get_employee_list, 
    get_designation, 
    get_company, 
    update_employee, 
    upload_files, 
    upload_documents, 
    delete_documents } from './actions/employee.edit.action';

const TabPane = Tabs.TabPane;
const { confirm } = Modal;

class EmployeeEdit extends Component {

    constructor( props ){
        super( props );

        this.state = {
            profile: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAMAAAD04JH5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABp1BMVEUAAACUxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP+UxP8AAABbCj+bAAAAi3RSTlMACUyIo73Y8hNisPVhC37zA2bnGso25lv3+LZnPiUMaA17CjfSHHUox8h2Kcl3KvzwEOoX5B3eJCvZMdMCTbf+OK9FARZ54NpyEjul+fafNdHLlPFS7o8mBVbA+qkhuwSD430YGbpQ+6tCEXGO124PM52bCGBejO3bc+yLI064R+HohB7CWJYsaac9omsgggAAAAFiS0dEAIgFHUgAAAAJcEhZcwAADdcAAA3XAUIom3gAAAAHdElNRQfiBxAMOxUtFGkRAAAD8ElEQVR42u2a+VvTMBzGYRxjG4yOs8DuMW4YNwgqMFREOURBUUAFBC888QAVuc/+0z6TpF2bNk27ZiJP3h+/3zd5P02ywNMtQyBUhkERz8sAGAADuDAARgNSFQNgAAzgEgBk2rKyc3Lt9tyc7CxbZroB8hxOV/J95nLm56URoMBdiN6phe6CNAFwniL1a73Iw6UDoLhE+y9LSTF9gNIyAaOyUtoA5byAFV9OF6Bc0BUhgTmA0uTnr6is8vr8fp+3qrIieQ3IdsEUQHHS/pcFglIjGEjuEJ1EMwCcdP75UFjeC4ekxSnhKAF4xIiiCNqNSLeDhw5AgZhQHVXrR6tFPoI70QSAW5w/qm6IioRuGgB58P7nI1qWCDwHhfp/mYwDOKAzpO0JQU8+BQAn/JSFtT1h+Gl0Wg+Q6QLGAM4VACaX7n8ohgFs8P4L4lxBeCfaLAfIAr5KvK0S2LIsB8gGviq8rQrYsi0HyAE+L97mBbYcywFygc+Ht/mALddyADvw+fE2P7DZiQFIRTrA8MQMgAEwgP8WQCuIATCAyw/A4YM46gA1eIAa6gB8Lc5Vy1MDqIMz13PaJq4euuosB5CerUHb1EC2TuYk7i7fqGVp5JUnxUpJy6u1CfqO1KS7CVQ3QBZQoboJjRUEpyQlSUvcxKl0m+hugPwZm9FmM359rJEU0qJsteDgLFPSMitb2O2xTuImxJSdWBo2ICFxExTPyaVjA/4GwSVQvqqFC8CZmtaAWkFSm7zcBsqttPMz2kFSh7zcAcrt1AE6QVKXvNwFyp3UAbpBUo+83APK3dQB4LuiXnm5F5SvUAeA7+T75OU+UO6nm3712vUBkDQo7wzCC2ooPkwt/sbNW4IoxftCr9QZuT1KJf7O3TEhSXF5N57cG5+YtDrdH7gnyKV4G21TtKccxr/R11bv/QeCUtNyyzRimHn4yJr02cdPkMmFufkFuWthfg4xDTydfpZyfPS5ynf1i0vLqHN5aRF1drpfpJI+HB+Koc+1ssqp27nVlQHE/vLVa7Pxb96OoI80s4Z9Xe5bm0HHvHv/wUT8x0/j6FQEZzvTMYWOc33uI8mUtP5F5WcSPOmne3JC5UcG9V/XieN7vn1HJ9jYNHC/jW5uoDP8+PmLZCy39Rs9STHntsEbfnjbqXJ+f29x0ABryMgdFH13b99Y+rn293bRuXZ0AZAhB4ezZuITmj08QKYzCGA/Ojabfq7jI7sOgFYjof6TYGrxCQVP+s0BjJ2epZ5+rrPTMeMAoQ5zYerqCBkGsDJebV4GwAAYAAPQBdAD0xunJQbAABjAxQdIlxgAA2AAFw+A5PIwE6A7NwNgAAzgXwP8AbJBBE/NLbRdAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA3LTE2VDEyOjU5OjIxKzAyOjAwY3lH1AAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxOC0wNy0xNlQxMjo1OToyMSswMjowMBIk/2gAAAAZdEVYdFNvZnR3YXJlAHd3dy5pbmtzY2FwZS5vcmeb7jwaAAAAAElFTkSuQmCC',
            data: [],
            department_data: [],
            employee_data: [],
            designation_data: [],
            company_data: [],
            assets_option: []
        }

        this.handleBack = this.handleBack.bind( this );
        this.handleSubmit = this.handleSubmit.bind( this ); 
        this.handleProfilePic = this.handleProfilePic.bind( this );
        this.handleDocuments = this.handleDocuments.bind( this );
        this.handleDeleteDoc = this.handleDeleteDoc.bind( this ); 

    }

    handleDeleteDoc( id ){
        let self = this

        confirm({
            title: 'Do you Want to delete these Doc?',
            content: '',
            onOk() {
                self.props.delete_documents( id );
            },
            onCancel() {
               // Nothing
            },
        });

    } 
    
    handleDocuments( data ){
        this.props.upload_documents( data );
    }

    handleProfilePic( e ){
        var fdata = new FormData();
        var user_id =  this.props.match.params.id;

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );

            });
        }

        this.props.upload_files( fdata );
    }

    handleSubmit( data ){
        this.props.update_employee( this.props.match.params.id , data )
    }

    handleBack(){
        this.props.history.goBack();
    }

    componentWillMount(){
        this.props.get_employee( this.props.match.params.id );
        this.props.get_department();
        this.props.get_employee_list();
        this.props.get_designation();
        this.props.get_company();
        this.props.get_assets();
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.employeeedit.length === 0 ){
            console.log( "Slow Data Fetching ..." );
            return false;
        }

        if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Successfully Listed Employee Edit" ) {
            this.setState({
                data: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Get Department" ) {
            this.setState({
                department_data: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Get Employee List" ) {
            this.setState({
                employee_data: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Get Designation" ) {
            this.setState({
                designation_data: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Get Company" ) {
            this.setState({
                company_data: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Successfully Updated Employee Edit" ) {

            message.success('Successfully Updated');
            
            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();
        
        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "File Uploaded" ) {
            
            message.success('Profile Picture seted');

            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Documents Uploaded" ) {
            
            message.success('Documents Uploaded');

            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Successfully Deleted Document" ) {
            
            message.success( nextProps.employeeedit.STATUS.MESSAGE );

            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();

        } else if( nextProps.employeeedit.STATUS.CODE === "400" ) {

            if( nextProps.employeeedit.STATUS.MESSAGE !== 'Error: 0 results' ){
                message.error( nextProps.employeeedit.STATUS.MESSAGE );
            }

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Successfully Listed Assets" ){

            this.setState({
                assets_option: nextProps.employeeedit.OUTPUT.DATA
            });

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE === "Successfully Created Asset" ){

            message.success( nextProps.employeeedit.STATUS.MESSAGE );
            
            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();

        } else if( nextProps.employeeedit.STATUS.CODE === "200" && 
            nextProps.employeeedit.STATUS.MESSAGE ==="Successfully Deleted Asset Log" ){

            message.success( "Successfully Deleted" );
            
            this.props.get_employee( this.props.match.params.id );
            this.props.get_department();
            this.props.get_employee_list();
            this.props.get_designation();
            this.props.get_company();
            this.props.get_assets();

        }

    }

    render() {

        return (
            <div className="profile_wrapper">
                <Row gutter={16}>
                    <Col span={18}>
                        <About 
                            {...this.props}
                            data={ this.state.data } 
                            department_data={ this.state.department_data }
                            employee_data={ this.state.employee_data }
                            designation_data={ this.state.designation_data }
                            company_data={ this.state.company_data }
                            onSubmit={ this.handleSubmit }
                            onDocument={ this.handleDocuments }
                            onDocDelete={ this.handleDeleteDoc }
                            onBack={ this.handleBack }
                            onAssets={ this.state.assets_option }
                            employee_id={ this.props.match.params.id } />
                    </Col>
                    <Col span={6}>
                        <div className="profile">
                            <div className="pic">
                                <div className="img_thumb">
                                    <div className="img_thumb_inner">
                                        <img src={ (this.state.data.picture) ? this.state.data.picture : this.state.profile } /> 
                                    </div>
                                </div>
                            </div>

                            <input onChange={ this.handleProfilePic } style={{ width: '220px',margin: '10px auto' }} type="file" />

                            <Link to={ '/prints/profile/'+ this.props.match.params.id }>
                                <Button style={{ width: '220px' }} icon="printer">Print Profile</Button>
                            </Link>
                            <Link to={ '/prints/expcertificate/'+ this.props.match.params.id }>
                                <Button style={{ width: '220px', marginTop: '10px' }} >Experience Certificate</Button>
                            </Link>
                            <Link to={ '/prints/exitinterview/'+ this.props.match.params.id }>
                                <Button style={{ width: '220px', marginTop: '10px' }} >Exit Interview</Button>
                            </Link>
                            
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        employeeedit: state.employeeedit
    }
}

export default connect( mapStatetoProps, { 
    get_assets, 
    get_employee, 
    get_department, 
    get_employee_list, 
    get_designation, 
    get_company, 
    update_employee, 
    upload_files, 
    upload_documents, 
    delete_documents } )( EmployeeEdit );



// WEBPACK FOOTER //
// ./src/pages/employee.edit/index.js